<template>
  <div class="vertical-list-display">
    <BaseText size="sm" :color="NebraskaColors.elementSecondary">
      {{ label }}
    </BaseText>
    <BaseText size="md" :color="valueColor">
      <SkeletonLoader v-if="isLoading">
        <div class="vertical-list-display--loader" />
      </SkeletonLoader>
      <component :is="valueComponent" v-else width="100%">{{
        valueFormatted
      }}</component>
    </BaseText>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BaseText, SkeletonLoader } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import { NumberFormatted } from '@/modules/trade/types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { getCurrencyTextColor } from '@/modules/common/helpers/currency';

interface Props {
  label: string;
  valueObject: NumberFormatted;
  shouldValueBeColored?: boolean;
  shouldHideValueWithMoneyToggle?: boolean;
  isLoading: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  shouldValueBeColored: false
});

const valueFormatted = computed(() => {
  return props.valueObject?.formatted || '-';
});

const valueColor = computed(() => {
  if (props.shouldValueBeColored && props.valueObject) {
    return getCurrencyTextColor(props.valueObject.value);
  }
  return NebraskaColors.elementPrimary;
});

const valueComponent = computed(() => {
  return props.shouldHideValueWithMoneyToggle ? Money : 'span';
});
</script>

<style lang="less" scoped>
.vertical-list-display {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &--loader {
    height: 26px;
    width: 100%;
    border-radius: @size-radius-x100;
  }
}
</style>
